<div
  class="flex flex-col"
  *ngFor="let oldFile of oldFiles; let i = index"
>
  <div class="flex items-start mt-[11px]">
    <div class="flex justify-start items-center">
      <div
        class="relative ml-[5px] w-[2rem] h-[2rem] border border-gray-300 rounded-md overflow-hidden"
      >
        <img
          [src]="getFileIcon(oldFile.file_path)"
          alt="File Preview"
          class="object-cover w-auto h-[100%] cursor-pointer"
        />
      </div>
    </div>

    <!-- Display File Name -->
    <span
      style="
        color: black;
        text-align: left;
        font-size: 18px;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: inline-block;
        overflow: visible;
        margin-left: 10px;
        margin-top: 5px;
      "
    >
      {{ oldFile?.title }}
    </span>

    <!-- Remove File Button -->
    <img
      src="assets/icons/trash.svg"
      alt="trash"
      class="object-cover w-auto cursor-pointer ml-[8px] !h-[13px] mt-[11px]"
      (click)="onRemove(oldFile)"
    />
  </div>
</div>
